<template>
  <b-dropdown
    size="sm"
    variant="link"
    no-caret
    toggle-class="p-0"
    menu-class="note-template-dropdown"
    data-testid="note-template-dropdown">
    <template #button-content>
      <!-- スロットはトグルの button 内に描画されるため、button を入れ子にしない -->
      <span class="btn btn-primary btn-sm toggle-button">
        テンプレ
      </span>
    </template>
    <b-dropdown-item-button
      v-for="noteTemplate in noteTemplates"
      :key="noteTemplate.id"
      button-class="d-flex"
      :active="noteTemplate.id === selectedId"
      @click="$emit('select', noteTemplate)">
      <div
        class="note-template-color mr-2"
        :style="{ backgroundColor: noteTemplate.color }" />
      <div class="note-template-text">
        {{ noteTemplate.name }}
      </div>
    </b-dropdown-item-button>
  </b-dropdown>
</template>

<script>
export default {
  name: 'NoteTemplateDropdownMenu',
  props: {
    noteTemplates: {
      type: Array,
      default: () => []
    },
    selectedId: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.toggle-button {
  height: 24px;
  padding: 4px 8px;
}

.note-template-color {
  width: 15px;
  min-width: 15px;
  height: 24px;
  border: 1px solid $grey02;
}

.note-template-text {
  width: calc(100% - 10px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>

<style lang="scss">
.note-template-dropdown {
  max-height: 400px;
  overflow-y: scroll;
  max-width: calc(100vw - 90px);
}
</style>
